// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const getPointsApiIdeasPointsGetParamsIndustryItemMax = 40;

export const getPointsApiIdeasPointsGetParamsIndustryDefault = [];
export const getPointsApiIdeasPointsGetParamsIndustryMax = 50;

export const getPointsApiIdeasPointsGetParamsDispositionDefault = [];
export const getPointsApiIdeasPointsGetParamsDispositionMax = 3;

export const getPointsApiIdeasPointsGetParamsVerdictDefault = [];
export const getPointsApiIdeasPointsGetParamsVerdictMax = 5;

export const getPointsApiIdeasPointsGetParamsStatusOneMax = 40;

export const getPointsApiIdeasPointsGetParamsQOneMax = 200;

export const GetPointsApiIdeasPointsGetParams = zod.object({
  "industry": zod.array(zod.string().max(getPointsApiIdeasPointsGetParamsIndustryItemMax)).max(getPointsApiIdeasPointsGetParamsIndustryMax).default(getPointsApiIdeasPointsGetParamsIndustryDefault),
  "disposition": zod.array(zod.enum(['active', 'parked', 'archived'])).max(getPointsApiIdeasPointsGetParamsDispositionMax).default(getPointsApiIdeasPointsGetParamsDispositionDefault),
  "verdict": zod.array(zod.enum(['go', 'conditional_go', 'no_go', 'researching', 'failed'])).max(getPointsApiIdeasPointsGetParamsVerdictMax).default(getPointsApiIdeasPointsGetParamsVerdictDefault),
  "status": zod.union([zod.string().max(getPointsApiIdeasPointsGetParamsStatusOneMax),zod.null()]).optional(),
  "q": zod.union([zod.string().max(getPointsApiIdeasPointsGetParamsQOneMax),zod.null()]).optional()
})

export type GetPointsApiIdeasPointsGetParams = zod.input<typeof GetPointsApiIdeasPointsGetParams>;
export type GetPointsApiIdeasPointsGetParamsOutput = zod.output<typeof GetPointsApiIdeasPointsGetParams>;
